<template>
  <div id="app">
    <nav-bar/>
    <div id="content">
        <template v-if="$route.matched.length">
            <router-view></router-view>
        </template>
        <template v-else>
          <h1>Oops! Nothing here</h1>
          <p>Please try a different url</p>
        </template>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'

export default {
  name: 'App',
  components:{
    'nav-bar': NavBar
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
$primary: #d00a0a;
$success: #00B251;
$info: #4D4D4D;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);
// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert),
);

$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

.navbar-item.router-link-exact-active{
  color: #7957d5;
}
.button {
    text-decoration: none !important;
}

.has-navbar-fixed-top{
  padding-top: 5.25rem !important;
}

@import "~bulma";
@import "~buefy/src/scss/buefy";

@media print {
  .no-print{
    display: none !important;
  }
  .column{
    padding: 0px 10px 0px 10px
  }
  body{
    font-size: .75rem !important;
    margin-top: 0px;
    padding-top: 0px;
    background-color: white;
  }
  .label{
    font-size: .75rem !important;
  }
  .textarea{
    font-size: .75rem !important;
  }
  .level-right{
    font-weight: bold;
  }
  .help, .icon{
    display: none !important;
  }
  .input{
    background-color:transparent !important;
    border: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    font-size: 11px !important;
    /*padding: 10px 10px 10px 10px;*/
    margin-top: 2px;
  }
    .select select:not([multiple]) {
      padding: 5px 0px 0px 0px !important;
      background-color: transparent !important;
      border: none !important;
      font-size: 11px;
    }
  .select::after{
    display: none !important;
  }
  .has-navbar-fixed-top{
    padding-top: 0px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/App.vue